import React, { useEffect, useState, useContext, forwardRef } from "react";
import "moment-timezone";
import moment from 'moment';
import SessionManager from "../../routes/SessionManager";
import Loading from "../Loading";
import $ from "jquery";
import Toastr from "toastr";
import { Context } from '../../views/app';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

const weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const getWorkSchedule = () => {
    var sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie("user");
    let work_schedule = user.site_selected.site_config.work_hours.work_schedule;
    if (!work_schedule) {
        work_schedule = {};
        for (let w of weekdays)
            work_schedule[w] = Array(48).fill(0);
    } else {
        if (work_schedule['monday'].length === 24) { // Backward compat for 24 len array.
            for (let w of weekdays) {
                let tmp = JSON.parse(JSON.stringify(work_schedule[w]));
                work_schedule[w] = Array(48).fill(0);
                for (let i = 0; i < tmp.length; i++)
                    if (tmp[i] === 1) {
                        work_schedule[w][(2 * i)] = 1;
                        work_schedule[w][(2 * i) + 1] = 1;
                    }
            }
        }
    }
    return work_schedule;
}

function AdvWorkHrsBreadcumb(props, refs) {
    let appContext = useContext(Context);
    let user = appContext.user;

    const [isHighlighted, setIsHighlighted] = useState();
    const [isMouseDown, setIsMouseDown] = useState();
    const [work_schedule, setWorkSchedule] = useState(getWorkSchedule());
    const [loading, setLoading] = useState(false);
    const [call, setCall] = useState(false);

    var m1 = moment().startOf('day');
    let hours = [];
    while (hours.length < 48) {
        hours.push(m1.format('h:mmA'));
        m1 = m1.add(30, 'minutes');
    }

    React.useImperativeHandle(refs, () => ({
        resetAdvancedWorkHours,
        updateSiteConfig,
        isChanged
    }));

    const isChanged = () => {
        var sessionMgr = new SessionManager();
        let userPrev = sessionMgr.readCookie("user");

        let isModified = false;
        let work_hours = { ...user.site_selected.site_config.work_hours };
        console.log(work_hours.work_schedule)
        work_hours.work_schedule = { ...work_schedule };
        isModified = JSON.stringify(userPrev.site_selected.site_config.work_hours.work_schedule) !== JSON.stringify(work_hours.work_schedule);

        return isModified;
    }

    /**
     * Resets the advanced work hours to the previously saved state.
     * Reads the user data from cookies and updates the work schedule accordingly.
     */
    const resetAdvancedWorkHours = () => {
        setWorkSchedule(getWorkSchedule);
    }

    useEffect(() => {
        if (!call) {
            isChanged();
        } else {
            isChanged();
            props.disableButtons();
        }
    }, [work_schedule]);


    const onSelected = (day, hr) => {
        var work_schedule1 = { ...work_schedule };
        var days = day.toLowerCase();
        var dayData = work_schedule1[days] ? work_schedule1[days] : Array(48).fill(0);
        dayData[hours.indexOf(hr)] = dayData[hours.indexOf(hr)] === 1 ? 0 : 1;
        work_schedule1[days] = dayData;

        setWorkSchedule(work_schedule1);
        setCall(true);
    }

    const updateSiteConfig = () => {
        var test = false;
        if (user.site_selected.site_config.work_hours.work_schedule) {
            for (var key of Object.keys(user.site_selected.site_config.work_hours.work_schedule)) {
                if (user.site_selected.site_config.work_hours.work_schedule[key].find(val => val === 1)) {
                    test = true;
                }
            }
            if (Object.keys(user.site_selected.site_config.work_hours.work_schedule).length === 0 || test === false) {
                Toastr.error("Advanced work hours schedule can't be empty");
                return;
            }
        }

        let site_config = user.site_selected.site_config;
        if (!site_config.work_hours)
            site_config.work_hours = {};

        site_config.work_hours.work_schedule = { ...work_schedule };
        console.log('work schedule', site_config);

        let data = {
            form_input: {
                customer_id: user.site_selected.customer_id,
                site_id: user.site_selected.site_id,
                site_config: JSON.stringify(site_config),
            },
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
        };

        setLoading(true);

        CommonUtils.ajax({
            url: API.SITE.CONFIG.UPDATE,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data),
        }).then(
            (res) => {
                if ((res.status && res.status.code !== 200) || (res.data && !(res.data.site_config || res.data.Attributes.site_config))) {
                    Toastr.error("An error occured ...please try again.", "Error");
                    $("#spinner").toggleClass("d-none");
                    return;
                }
                Toastr.success("Modified successfully", "Status");
                $("#spinner").toggleClass("d-none");
                let user1 = { ...user };
                let site_config = res.data.site_config || res.data.Attributes.site_config;
                if (user1.site_locations) {
                    for (let site of user.site_locations) {
                        if (site.site_id === user.site_selected.site_id) {
                            site.site_config = site_config;
                        }
                    }
                }
                user1.site_selected.site_config = site_config;
                setLoading(false);
                setWorkSchedule(user1.site_selected.site_config.work_hours.work_schedule);

                console.log('user1 --- >', user1);

                appContext.updateUser(user1);
                $.event.trigger("work_hours_updated");
                $.event.trigger("refresh_notifications");
            },
            (err) => {
                Toastr.error("An error occured ...please try again.", "Error");
                $("#spinner").toggleClass("d-none");
            }
        );
    };

    return (
        <React.Fragment>
            {loading && (<div> <Loading> Saving Advanced Work Hours Information ...</Loading> </div>)}

            {!loading && (<React.Fragment>
                <div className="d-flex">
                    <table className="font-size-13">
                        <tbody>
                            <tr><td colSpan="49">&nbsp;</td></tr>
                            {weekdays.map((day, index) => (
                                <>
                                    <tr key={index} >
                                        <td key={index} className="text-capitalize">{day}</td>
                                    </tr>
                                </>
                            ))}
                        </tbody>
                    </table>
                    <div
                        style={{ overflowX: "auto" }}
                        onMouseUp={(e) => {
                            e.preventDefault();
                            setIsMouseDown(false);
                        }}
                    >
                        <table className="adv-work-hrs">
                            <tbody>
                                <tr>
                                    {hours.map((hr, index) => (<th width='100'
                                        height='20' key={index} > {hr} </th>))}
                                </tr>
                                {weekdays.map((day, index) => (
                                    <>
                                        <tr><th colSpan="48"></th></tr>
                                        <tr key={index} >
                                            {hours.map((hr, i) => (
                                                <td
                                                    width='100'
                                                    height='20'
                                                    key={i}
                                                    onMouseDown={(e) => {
                                                        if (props.view_only)
                                                            return;
                                                        e.preventDefault();
                                                        setIsMouseDown(true);
                                                        $(e.currentTarget).toggleClass("highlighted");
                                                        setIsHighlighted($(e.currentTarget).hasClass("highlighted"));
                                                        onSelected(day, hr);
                                                        return false;
                                                    }}
                                                    onMouseOver={(e) => {
                                                        e.preventDefault();
                                                        if (isMouseDown) {
                                                            $(e.currentTarget).toggleClass("highlighted", isHighlighted);
                                                            onSelected(day, hr);
                                                        }
                                                    }}
                                                    onMouseUp={(e) => {
                                                        e.preventDefault();
                                                        setIsMouseDown(false);
                                                    }}
                                                    className={
                                                        work_schedule[day.toLowerCase()] &&
                                                            work_schedule[day.toLocaleLowerCase()][hours.indexOf(hr)] === 1 ? "highlighted" : ""
                                                    }
                                                >
                                                </td>
                                            ))}
                                        </tr>
                                    </>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </React.Fragment>
            )
            }
        </React.Fragment >
    );
}

export default forwardRef(AdvWorkHrsBreadcumb);